/** Sample defaults from res/GL/GL/AEL 24-25 30-01-26.xlsm (C sheets).
 * Applied only when a field is blank — saved/user values always win.
 */

import type {AuditProgramSectionVO} from '@/services/auditService/auditProgramService';
import {C1_DEFAULT_VALUES, type CSectionPageCode} from '@/pages/components/audit-program/c-section/constants';

function isBlank(v?: string | null): boolean {
    return v == null || String(v).trim() === '';
}

export const C_PAGE_DEFAULTS: Partial<Record<CSectionPageCode, Record<string, string>>> = {
    'C1': {
        "completionPartnerDate": "30/01/2026",
        "partnerDate": "16/01/2026",
        "team.manager.date": "16/01/2026",
        "team.manager.initials": "ML",
        "team.manager.name": "Matthew Law",
        "team.partner.date": "16/01/2026",
        // partner name / initials come from audit certificate (header.partnerName / reviewedInitial)
        "team.senior.date": "16/01/2026",
        "team.senior.initials": "PC",
        "team.senior.name": "Paul Chung",
        ...C1_DEFAULT_VALUES,
    },
    'C1a': {
        "clientRiskRating": "Low Risk",
        "engagementDecision": "accept",
        "natureOfAssignment": "Audit",
        "r102.yesNo": "No",
        "r108.yesNo": "No",
        "r114.yesNo": "No",
        "r115.yesNo": "No",
        "r116.yesNo": "No",
        "r117.yesNo": "No",
        "r118.yesNo": "No",
        "r119.yesNo": "No",
        "r120.yesNo": "No",
        "r121.yesNo": "No",
        "r122.yesNo": "No",
        "r123.yesNo": "No",
        "r124.yesNo": "No",
        "r125.yesNo": "No",
        "r126.yesNo": "No",
        "r127.yesNo": "No",
        "r128.yesNo": "No",
        "r129.yesNo": "No",
        "r131.yesNo": "No",
        "r134.yesNo": "No",
        "r142.yesNo": "Yes",
        "r143.yesNo": "Yes",
        "r145.yesNo": "Yes",
        "r146.yesNo": "Yes",
        "r147.yesNo": "Yes",
        "r148.yesNo": "Yes",
        "r149.yesNo": "Yes",
        "r15.response": "New Client, perform company search for the Company",
        "r15.yesNo": "No",
        "r154.yesNo": "No",
        "r157.yesNo": "N/A",
        "r172.date": "31/08/2026",
        "r19.yesNo": "No",
        "r20.yesNo": "No",
        "r21.yesNo": "No",
        "r22.yesNo": "No",
        "r23.yesNo": "No",
        "r24.yesNo": "No",
        "r27.yesNo": "N/A",
        "r34.yesNo": "N/A",
        "r48.yesNo": "Yes",
        "r49.yesNo": "Yes",
        "r51.yesNo": "Yes",
        "r60.yesNo": "No",
        "r61.yesNo": "No",
        "r62.yesNo": "No",
        "r63.yesNo": "No",
        "r64.yesNo": "No",
        "r65.yesNo": "No",
        "r66.yesNo": "No",
        "r67.yesNo": "No",
        "r68.yesNo": "No",
        "r69.yesNo": "No",
        "r75.yesNo": "Yes",
        "r76.yesNo": "Yes",
        "r78.yesNo": "No",
        "r79.yesNo": "No",
        "r80.yesNo": "No",
        "r81.yesNo": "No",
        "r82.yesNo": "No",
        "r85.yesNo": "No",
        "r86.yesNo": "No",
        "r89.yesNo": "No",
        "r90.yesNo": "No",
        "r93.yesNo": "No",
        "r94.yesNo": "No",
        "r97.yesNo": "No",
        "r98.yesNo": "No",
        "r99.yesNo": "No",
    },
    'C2': {
        "r7.comments": "Completed",
        "r7.wpRef": "C2.1\nC2.2",
        "r9.comments": "N/A",
        "r10.comments": "N/A",
        "r11.comments": "N/A",
        "r12.comments": "No significant changes",
        "r13.comments": "N/A",
        "r15.comments": "N/A",
        "r16.comments": "N/A",
        "r17.comments": "N/A",
        "r22.comments": "We forsee that there would not be resulted in disclaimer of opinion.",
        "r24.comments": "N/A",
        "r27.comments": "No",
        "r28.comments": "No",
        "r29.comments": "No",
        "r30.comments": "No",
        "r31.comments": "No",
        "r32.comments": "No",
        "r33.comments": "No",
        "r34.comments": "No",
        "r36.comments": "Confirmed in updated engagement letter",
        "r38.comments": "SME-FRS was adopted",
        "r40.comments": "No",
        "r41.comments": "No",
        "r42.comments": "No",
        "r43.comments": "No",
        "r44.comments": "No",
        "r45.comments": "No",
        "r46.comments": "No",
        "r47.comments": "No",
        "r48.comments": "Yes per engagement letter",
        "r49.comments": "Yes per engagement letter",
        "r50.comments": "YEUNG Kin the director",
        "r51.comments": "N/A",
        "r54.comments": "YEUNG Kin the director",
        "r55.comments": "N/A",
    },
    'C2.1': {
        "r8.answer": "No",
        "r10.answer": "No",
        "r12.answer": "No",
        "r14.answer": "No",
        "r16.answer": "No",
        "r18.answer": "No",
        "r24.answer": "No",
        "r28.answer": "No",
        "r30.answer": "No",
        "r33.answer": "No",
        "r36.answer": "No",
        "r38.answer": "No",
        "r40.answer": "No",
        "r44.answer": "No",
        "r49.answer": "No",
        "r51.answer": "No",
        "r57.answer": "No",
        "r59.answer": "No",
        "r62.answer": "No",
        "r64.answer": "No",
        "r70.answer": "No",
        "r72.answer": "No",
        "r76.answer": "No",
        "r78.answer": "No",
        "r81.answer": "No",
        "r83.answer": "No",
        "r85.answer": "No",
        "r87.answer": "No",
        "r89.answer": "No",
        "r95.answer": "No",
        "r97.answer": "No",
        "r99.answer": "No",
        "r101.answer": "No",
        "r104.answer": "No",
        "r106.answer": "No",
        "r113.answer": "No",
        "r115.answer": "No",
        "r117.answer": "No",
        "r119.answer": "No",
        "r122.answer": "No",
        "r125.answer": "No",
        "r135.answer": "No",
        "r137.answer": "No",
        "r139.answer": "No",
        "r141.answer": "No",
        "r143.answer": "No",
        "r145.answer": "No",
        "r147.answer": "No",
        "r149.answer": "No",
        "r152.answer": "No",
        "r155.answer": "No",
        "r158.answer": "No",
        "r162.answer": "No",
        "r165.answer": "No",
        "r170.answer": "No",
        "r173.answer": "Yes",
        "r178.answer": "No",
        "r181.answer": "No",
        "r185.answer": "No",
        "r188.answer": "No",
        "r193.answer": "No",
        "r195.answer": "No",
        "r198.answer": "No",
        "r203.answer": "No",
        "r206.answer": "No",
        "r210.answer": "No",
        "r215.answer": "No",
        "r219.answer": "No",
        "r222.answer": "No",
        "r225.answer": "No",
        "r228.answer": "No",
        "r231.answer": "No",
        "r235.answer": "No",
        "r240.text": "N/A",
        "r242.text": "2. We provide tax compliance services to the client. As the tax computation and any tax adjustments will be subject to approval by the client, these services do not require significant judgements to be made and are hence not a threat to our independence as auditor.",
        "r252a.text": "1. We prepare management accounts for the client. Management accounts will be subject to approval by the client and separate accounting and audit staff were engaged, hence it is not a threat to our independence as auditor.\n\nWe prepare the statutory accounts from a trial balance; however, the client approves all journal adjustments and also approves the wording of any narrative notes. The affair of the client are routine, there are no contentious areas. There is therefore no significant threat to our independence as auditor and specific safeguards are not required.",
        "engagementPartnerDate": "21/08/2026",
    },
    'C2.2': {
        "engagementPartnerDate": "16/01/2026",
        "r7.level": "Low",
        "r13.level": "Low",
    },
    'C3.1': {
        "r7.comments": "Yes",
        "r8.comments": "Yes",
        "r9.comments": "Yes",
        "r10.comments": "Yes",
        "r11.comments": "Yes",
        "r12.comments": "Yes",
        "r13.comments": "Yes",
        "r14.comments": "Yes",
        "r16.comments": "Yes",
        "r17.comments": "Yes",
        "r17.wpRef": "D11",
        "r18.comments": "N/A",
        "r18.wpRef": "D10",
        "r20.comments": "Yes",
        "r20.wpRef": "C5\nC5.1",
        "r21.comments": "Yes",
        "r21.wpRef": "C7\nC7.1",
        "r22.comments": "Yes",
        "r22.wpRef": "C8.2\nC8.3\nC8.4",
        "r23.comments": "Yes",
        "r24.comments": "Yes",
        "r24.wpRef": "C3.2",
        "r25.comments": "Yes",
    },
    'C4': {
        "r7.comments": "Yes",
        "r7.wpRef": "PAF04",
        "r8.comments": "Yes",
        "r9.comments": "N/A",
        "r9.wpRef": "PAF06",
        "r10.comments": "N/A",
        "r11.comments": "Done",
        "r13.comments": "Yes",
        "r13.wpRef": "PAF07",
        "r14.comments": "Yes",
        "r14.wpRef": "PAF04",
        "r15.comments": "Yes",
        "r15.wpRef": "PAF04",
        "r17.comments": "We consider that there is no area of non-compliance with relevant laws and regulation",
        "r18.comments": "Yes",
        "r21.comments": "Evaluated and results are satifactory",
        "r22.comments": "Evaluated and results are satifactory",
        "r23.comments": "Evaluated and results are satifactory",
        "r26.comments": "Evaluated and results are satifactory",
        "r30.comments": "Evaluated and results are satifactory",
        "r31.wpRef": "PAF03.4",
        "r34.comments": "Evaluated and results are satifactory",
        "r35.wpRef": "PAF3.4",
        "r37.comments": "Yes",
        "r37.wpRef": "PAF13",
        "r38.comments": "Done",
        "r38.wpRef": "C4.1",
        "r39.wpRef": "C4.1",
        "r40.comments": "N/A",
        "r41.comments": "N/A",
        "r42.comments": "N/A",
        "r43.wpRef": "C4.1",
        "r44.comments": "N/A",
        "r48.wpRef": "C4.1",
        "r49.comments": "N/A",
        "r50.comments": "N/A",
        "r51.comments": "Done",
        "r51.wpRef": "C8.3",
    },
    'C4.1': {
        "e1.estimate": "Depreciation",
        "e1.outcome": "The outcome of the previous year's estimate was reviewed and no significant variations in assumptions or indicators of bias were identified. The previous estimate was found to be reasonable.",
        "e1.inherent": "Degree of estimation uncertainty - Low, assets are standard industrial machinery with predictable usage patterns. Useful lives have remained consistent over time, and no significant changes in technology or operating conditions have occurred.\nSelection and application of method and data - Low, the depreciation method is consistent.\nDegree of complexity - low, depreciated on a straight-line method\nDegree of subjectivity - high, rely on significant judgment on asset's useful life",
        "e1.control": "Useful live assumptions are determined, reviewed and approved by the directors only, subject to high risk of management override.",
        "e1.overall": "The overall risk has been assessed as Moderate and carried forward to C8.3. Given the relative simplicity of the method used, the availability of the data used and the limited nature of controls, a substantive approach will be applied.",
        "e1.d3": "No.\n\nThis estimate is not complex and is straight-forward. D3 is not used.",
    },
    'C5': {
        "r6.comments": "Yes",
        "r6.wpRef": "C5.2",
        "r7.comments": "Yes",
        "r7.wpRef": "C5.1",
        "r8.comments": "Yes",
        "r8.wpRef": "C5.1",
        "r9.comments": "N/A",
        "r9.wpRef": "A6",
        "r10.comments": "N/A",
        "r10.wpRef": "C4, C5.1",
        "r11.comments": "N/A",
        "r11.wpRef": "C8.3",
        "r12.comments": "N/A",
        "r12.wpRef": "S3",
    },
    'C5.1': {
        "r7.area": "Sales",
        "r7.desc": "1. All customer orders are approved by\nthe director in terms of their\nbackground, credit worthiness, ability to satisfy order ",
        "r7.design": "This is a straightforward, effective control.",
        "r7.impl": "Good in control. The director was involvement in daily business.",
        "r7.key": "Y",
        "r7.further": "N",
        "r7.ice": "N/A",
        "r8.area": "Sales",
        "r8.desc": "1. There was prompt billing of all sales and sequentially numbered invoices were used. 2. Sales ledger control accounts are reconciled.",
        "r8.design": "This is a straightforward, effective control.",
        "r8.impl": "Good in control. The director was involvement in daily business.",
        "r8.key": "Y",
        "r8.further": "N",
        "r8.ice": "N/A",
        "r9.area": "Sales",
        "r9.desc": "The picking list, despatch note and sales invoice are the document for verification and reconciliation against each other.\nTherefore goods cannot be despatched\nwithout an invoice being raised.",
        "r9.design": "This is a straightforward, effective control.",
        "r9.impl": "Good in control. The director was involvement in daily business.",
        "r9.key": "Y",
        "r9.further": "N",
        "r9.ice": "N/A",
        "r10.area": "Property, plant and\nequipment\nPhysical control: ",
        "r10.desc": "N/A",
        "r10.design": "N/A",
        "r10.impl": "N/A",
        "r10.key": "N/A",
        "r10.further": "N/A",
        "r10.ice": "N/A",
        "r11.area": "Inventory",
        "r11.desc": "N/A",
        "r11.design": "N/A",
        "r11.impl": "N/A",
        "r11.key": "N/A",
        "r11.further": "N/A",
        "r11.ice": "N/A",
        "r12.area": "Bank & cash",
        "r12.desc": "All bank accounts are reconciled monthly \n",
        "r12.design": "The reconciliation enables any\nirregularities with cash and bank be\nidentified. Hence, it is considered to be an effective control.",
        "r12.impl": "Good in control. The director was involvement in daily business.",
        "r12.key": "Y",
        "r12.further": "N",
        "r12.ice": "N/A",
        "r13.area": "Payments",
        "r13.desc": "Payment vouchers should be captured, prepared and authorised together with the relevant supporting documents with the signatures of the preparer and the authoriser.",
        "r13.design": "This is a straightforward, effective control.",
        "r13.impl": "Good in control. The director was involvement in daily business.",
        "r13.key": "Y",
        "r13.further": "N",
        "r13.ice": "N/A",
        "r14.area": "Receivables",
        "r14.desc": "Customer are mainly customers with long term relationship. The director confirm they are good relationship and continue business with the Company.",
        "r14.design": "This is a straightforward, effective control.",
        "r14.impl": "Good in control. The director was involvement in daily business.",
        "r14.key": "Y",
        "r14.further": "N",
        "r14.ice": "N/A",
    },
    'C5.2': {
        "r10.relevant": "N/A",
        "r11.relevant": "N/A",
        "r12.relevant": "N/A",
        "r13.relevant": "N/A",
        "r16.relevant": "N",
        "r17.relevant": "N",
        "r18.relevant": "N",
        "r18.refControl": "C5.1",
        "r19.relevant": "N",
        "r20.relevant": "N",
        "r21.relevant": "N",
        "r22.relevant": "N",
        "r23.relevant": "N/A",
        "r25.relevant": "Y",
        "r25.refControl": "C5.1",
        "r26.relevant": "Y",
        "r26.refControl": "C5.1",
        "r27.relevant": "Y",
        "r27.refControl": "C5.1",
        "r28.relevant": "Y",
        "r28.refControl": "C5.1",
        "r29.relevant": "Y",
        "r30.relevant": "Y",
        "r31.relevant": "Y",
        "r32.relevant": "Y",
        "r33.relevant": "Y",
        "r34.relevant": "Y",
        "r35.relevant": "N/A",
        "r37.relevant": "Y",
        "r38.relevant": "Y",
        "r39.relevant": "Y",
        "r40.relevant": "Y",
        "r41.relevant": "Y",
        "r42.relevant": "Y",
        "r43.relevant": "N/A",
        "r45.relevant": "N/A",
        "r46.relevant": "N/A",
        "r47.relevant": "N/A",
        "r48.relevant": "N/A",
        "r49.relevant": "N/A",
        "r50.relevant": "N/A",
        "r51.relevant": "N/A",
        "r53.relevant": "N/A",
        "r54.relevant": "N/A",
        "r55.relevant": "N/A",
        "r56.relevant": "N/A",
        "r57.relevant": "N/A",
        "r59.relevant": "Y",
        "r60.relevant": "Y",
        "r61.relevant": "Y",
        "r62.relevant": "Y",
        "r63.relevant": "Y",
        "r64.relevant": "Y",
        "r65.relevant": "Y",
        "r66.relevant": "Y",
        "r67.relevant": "Y",
        "r68.relevant": "N/A",
        "r70.relevant": "Y",
        "r71.relevant": "Y",
        "r72.relevant": "Y",
        "r73.relevant": "N/A",
        "r75.relevant": "N/A",
        "r76.relevant": "N/A",
        "r77.relevant": "N/A",
        "r78.relevant": "N/A",
        "r8.relevant": "N/A",
        "r9.relevant": "N/A",
    },
    'C6': {
        "r10.comments": "N/A",
        "r11.comments": "N/A",
        "r13.comments": "Done",
        "r14.comments": "N/A",
        "r15.comments": "Information are reliable to perform analytical review procedures and this will be verified as part of the audit process.",
        "r16.comments": "The comparisons used are sufficiently precise to identify potential misstatements.",
        "r18.comments": "N/A",
        "r18.wpRef": "C8.3",
        "r19.comments": "N/A",
        "r20.comments": "Done",
        "r23.comments": "N/A",
        "r24.comments": "N/A",
        "r26.comments": "N/A",
        "r27.comments": "N/A",
        "r30.comments": "N/A",
        "r31.comments": "N/A",
        "r32.comments": "N/A",
        "r33.comments": "N/A",
        "r7.comments": "Per our last yr WP file",
        "r8.comments": "N/A",
        "r9.comments": "N/A",
    },
    'C8': {
        "r10.comments": "Enquired NG Shing Pan (Director) on ________.   No formal risk assessment undertaken",
        "r11.comments": "NG Shing Pan has confirmed that he has no knowledge of actual or suspected fraud.",
        "r16.comments": "N/A",
        "r17.comments": "Informal approach appropriate size of business",
        "r18.comments": "N/A",
        "r19.comments": "Client's approach is appropriate to the size of business",
        "r20.comments": "Yes",
        "r22.comments": "N/A",
        "r23.comments": "Yes",
        "r24.comments": "Yes",
        "r25.comments": "Yes",
        "r26.comments": "N/A",
        "r27.comments": "N/A",
        "r28.comments": "Yes",
        "r30.comments": "N/A",
        "r31.comments": "N/A",
        "r32.comments": "N/A",
        "r33.comments": "No high risk was assessed",
        "r36.comments": "Reviewed the PAF",
        "r37.comments": "Yes",
        "r38.comments": "N/A",
        "r39.comments": "Yes",
        "r40.comments": "Done",
        "r41.comments": "N/A",
        "r42.comments": "Sample selected randomly. No other unpredictability in testing is consider necessary.",
        "r43.comments": "Appropriate",
        "r44.comments": "Appropriate",
        "r45.comments": "Done",
        "r7.comments": "Risk assessment completed this year",
    },
    'C8.1': {
        "r9.level": "L",
        "r9.specific": "No particular concerns",
        "r10.level": "L",
        "r10.specific": "No",
        "r11.level": "L",
        "r11.specific": "No",
        "r12.level": "L",
        "r12.specific": "No concerns",
        "r13.level": "L",
        "r13.specific": "No",
        "r14.level": "L",
        "r14.specific": "Good relationship with the client",
        "r15.level": "L",
        "r15.specific": "No",
        "r16.level": "L",
        "r16.specific": "No",
        "r23.level": "L",
        "r23.specific": "No",
        "r24.level": "L",
        "r24.specific": "No",
        "r25.level": "L",
        "r25.specific": "No",
        "r26.level": "L",
        "r26.specific": "No",
        "r27.level": "L",
        "r27.specific": "No",
        "r28.level": "L",
        "r28.specific": "No",
        "r29.level": "N/A",
        "r29.specific": "None",
        "r31.level": "N/A",
        "r31.specific": "None",
        "r32.level": "N/A",
        "r32.specific": "None",
        "r33.level": "N/A",
        "r33.specific": "None",
        "r35.level": "L",
        "r35.specific": "No, the company has a simple capital structure",
        "r36.level": "L",
        "r36.specific": "No",
        "r37.level": "L",
        "r37.specific": "No",
        "r38.level": "L",
        "r38.specific": "No",
        "r39.level": "L",
        "r39.specific": "No",
        "r40.level": "L",
        "r40.specific": "No",
        "r41.level": "L",
        "r41.specific": "No",
        "r42.level": "L",
        "r42.specific": "No",
        "r43.level": "L",
        "r43.specific": "No",
        "r44.level": "L",
        "r44.specific": "No",
        "r46.level": "L",
        "r46.specific": "No formal plans",
        "r47.level": "L",
        "r47.specific": "No",
        "r48.level": "L",
        "r48.specific": "No",
        "r49.level": "L",
        "r49.specific": "No",
        "r50.level": "L",
        "r50.specific": "No",
        "r51.level": "L",
        "r51.specific": "No",
        "r52.level": "N/A",
        "r52.specific": "None",
        "r53.level": "N/A",
        "r53.specific": "None",
        "r54.level": "N/A",
        "r54.specific": "No plans",
        "r55.level": "L",
        "r55.specific": "Management involved in the setting of the provision in the first instance",
        "r56.level": "L",
        "r56.specific": "No",
        "r57.level": "L",
        "r57.specific": "Only tax adjustment",
        "r58.level": "L",
        "r58.specific": "No",
        "r59.level": "L",
        "r59.specific": "Comfortably within SME-FRS",
        "r60.level": "L",
        "r60.specific": "No",
        "r61.level": "L",
        "r61.specific": "No",
        "r62.level": "L",
        "r62.specific": "No",
        "r64.level": "L",
        "r64.specific": "No",
        "r65.level": "L",
        "r65.specific": "No",
        "r66.level": "L",
        "r66.specific": "No",
        "r67.level": "L",
        "r67.specific": "No",
        "r69.level": "N/A",
        "r69.specific": "No external regulator",
        "r70.level": "N/A",
        "r71.level": "N/A",
        "r72.level": "N/A",
        "r73.level": "N/A",
        "r74.level": "N/A",
        "r76.level": "L",
        "r76.specific": "No",
        "r77.level": "L",
        "r77.specific": "No",
        "r78.level": "L",
        "r78.specific": "No",
        "r79.level": "L",
        "r79.specific": "No",
        "r81.level": "L",
        "r81.specific": "Yes",
        "r82.level": "L",
        "r82.specific": "Yes",
        "r83.level": "L",
        "r83.specific": "No",
        "r84.level": "L",
        "r84.specific": "No",
        "r85.level": "L",
        "r85.specific": "Yes",
        "r87.level": "L",
        "r87.specific": "Yes",
        "r88.level": "L",
        "r89.specific": "N/A",
        "r90.specific": "Yes",
        "r91.specific": "N/A",
        "r92.specific": "N/A",
        "r93.level": "L",
        "r93.managed": "IRD tax correspondence checked",
        "r93.specific": "No",
        "r94.level": "L",
        "r95.specific": "N/A",
        "r96.specific": "N/A",
        "r97.specific": "N/A",
        "r98.specific": "N/A",
        "r99.specific": "N/A",
        "r100.specific": "N/A",
        "r101.specific": "N/A",
        "r102.specific": "N/A",
        "r103.specific": "N/A",
        "r105.level": "L",
        "r105.specific": "Yes",
        "r106.level": "L",
        "r106.specific": "Yes",
        "r107.level": "L",
        "r107.specific": "Yes",
        "r108.level": "H",
        "r108.managed": "C8.3",
        "r108.specific": "Yes",
        "r109.level": "L",
        "r109.specific": "Yes",
        "r111.level": "L",
        "r111.specific": "No formal risk assessment process",
        "r113.level": "L",
        "r113.specific": "No",
        "r114.level": "L",
        "r114.specific": "Yes",
        "r115.level": "L",
        "r115.specific": "No",
        "r117.level": "L",
        "r117.specific": "Yes",
        "r118.level": "L",
        "r118.specific": "No",
        "r119.level": "L",
        "r119.specific": "No",
        "r120.level": "L",
        "r120.specific": "No",
        "r122.level": "L",
        "r122.specific": "No",
        "r123.level": "L",
        "r123.specific": "No",
        "r125.level": "L",
        "r125.specific": "No",
        "r126.level": "L",
        "r126.specific": "No",
        "r127.level": "L",
        "r127.specific": "No",
        "r128.level": "L",
        "r128.specific": "No",
        "r129.level": "L",
        "r129.specific": "No",
        "r130.level": "L",
        "r130.specific": "No",
        "r131.level": "L",
        "r131.specific": "No",
        "r132.level": "L",
        "r132.specific": "No",
        "r133.level": "L",
        "r133.specific": "No",
        "r134.level": "L",
        "r134.specific": "No",
        "r135.level": "L",
        "r135.specific": "Yes",
        "r136.level": "L",
        "r136.specific": "No",
        "r137.level": "L",
        "r137.specific": "No",
        "r138.level": "L",
        "r138.specific": "No",
        "r139.level": "L",
        "r139.specific": "No",
        "r141.level": "L",
        "r141.specific": "No",
        "r142.level": "N/A",
        "r142.specific": "None",
        "r143.level": "L",
        "r143.specific": "Director's C/A",
        "r144.level": "L",
        "r144.specific": "Yes, but the amount is not material",
        "r145.level": "L",
        "r145.specific": "No",
        "r146.level": "L",
        "r146.specific": "No",
        "r147.level": "L",
        "r147.specific": "No",
        "r148.level": "L",
        "r148.specific": "No",
        "r149.level": "L",
        "r149.specific": "No",
        "r150.level": "L",
        "r150.specific": "No",
        "r152.level": "N/A",
        "r152.specific": "None",
        "r153.level": "N/A",
        "r154.level": "N/A",
        "r155.level": "N/A",
        "r156.level": "N/A",
        "r157.level": "N/A",
        "r158.level": "N/A",
        "r159.level": "N/A",
        "r160.level": "N/A",
        "r161.level": "N/A",
        "r162.level": "N/A",
    },
    'C8.2': {
        "rowIds": "r6,r7",
        "r6.ref": "1",
        "r6.risk": "No pervasive risks of misstatement have been identified.",
        "r6.rmm": "Low",
        "r6.response": "The assessment of risk at financial statement level is low.",
        "r6.outcome": "N/A",
        "r7.ref": "2",
        "r7.risk": "What would happen if directors or key staff became ill or resigned?",
        "r7.rmm": "Low",
        "r7.response": "Discuss with client",
        "r7.outcome": "B6.1.2",
    },
    'C8.3': {
        "risk1.classes": "Completeness of income and trade receivables",
        "risk1.description": "Fraud concerning revenue recognition - a high risk presumed by HKSA 240",
        "risk1.inherent": "L",
        "risk2.classes": "All",
        "risk2.description": "Management override of controls - a high risk presumed by HKSA 240",
        "risk2.inherent": "L",
    },
    'C8.4': {
        "r12.risks": "N/A",
        "r13.risks": "N/A",
        "r14.risks": "N/A",
        "r15.risks": "N/A",
        "r16.risks": "N/A",
        "r17.risks": "N/A",
        "r18.risks": "N/A",
        "r19.risks": "None",
        "r19.residual": "Low",
        "r19.justification": "Straightforward area with no problems expected.",
        "r19.approach": "Standard programme",
        "r20.risks": "N/A",
        "r21.risks": "N/A",
        "r22.risks": "None",
        "r22.residual": "Low",
        "r22.justification": "Straightforward area with no problems expected.",
        "r22.approach": "Standard programme",
        "r23.risks": "None",
        "r23.residual": "Low",
        "r23.justification": "Straightforward area with no problems expected.",
        "r23.approach": "Standard programme",
        "r24.risks": "1. Management override of controls",
        "r24.residual": "High",
        "r24.justification": "Controls in this area is designed and implemented. Management override may affect this area.",
        "r24.approach": "Standard programme and compliance test of controls in Section S and specify approach on C8.3 #1",
        "r26.risks": "None",
        "r26.residual": "Low",
        "r26.justification": "Straightforward area with no problems expected.",
        "r26.approach": "Standard programme",
        "r27.risks": "None",
        "r27.residual": "Low",
        "r27.justification": "Straightforward area with no problems expected.",
        "r27.approach": "Standard programme",
        "r28.risks": "None",
        "r28.residual": "Low",
        "r28.justification": "Straightforward area with no problems expected.",
        "r28.approach": "Standard programme",
        "r29.risks": "N/A",
        "r30.risks": "None",
        "r30.residual": "L",
        "r30.justification": "Straightforward area with no problems expected.",
        "r30.approach": "Standard programme",
        "r31.risks": "None",
        "r31.residual": "L",
        "r31.justification": "Straightforward area with no problems expected.",
        "r31.approach": "Standard programme",
        "r32.risks": "N/A",
    },
    'C9': {
    },
    'C9.1': {
        "r101.answer": "No",
        "r103.answer": "No",
        "r105.answer": "No",
        "r107.answer": "No",
        "r11.answer": "No",
        "r121.answer": "No",
        "r125.answer": "No",
        "r127.answer": "No",
        "r129.answer": "No",
        "r13.answer": "No",
        "r134.answer": "No",
        "r136.answer": "No",
        "r138.answer": "No",
        "r140.answer": "No",
        "r144.answer": "No",
        "r146.answer": "No",
        "r148.answer": "No",
        "r15.answer": "No",
        "r150.answer": "No",
        "r152.answer": "No",
        "r154.answer": "No",
        "r156.answer": "No",
        "r158.answer": "No",
        "r160.answer": "No",
        "r162.answer": "No",
        "r164.answer": "No",
        "r166.answer": "No",
        "r169.answer": "No",
        "r17.answer": "No",
        "r171.answer": "No",
        "r173.answer": "No",
        "r175.answer": "No",
        "r177.answer": "No",
        "r19.answer": "No",
        "r21.answer": "No",
        "r23.answer": "No",
        "r27.answer": "No",
        "r29.answer": "No",
        "r31.answer": "No",
        "r33.answer": "No",
        "r37.answer": "No",
        "r39.answer": "No",
        "r41.answer": "No",
        "r45.answer": "No",
        "r50.answer": "No",
        "r52.answer": "No",
        "r54.answer": "No",
        "r56.answer": "No",
        "r58.answer": "No",
        "r60.answer": "No",
        "r62.answer": "No",
        "r66.answer": "No",
        "r68.answer": "No",
        "r72.answer": "No",
        "r74.answer": "No",
        "r76.answer": "No",
        "r80.answer": "No",
        "r82.answer": "No",
        "r84.answer": "No",
        "r87.answer": "No",
        "r89.answer": "No",
        "r91.answer": "No",
        "r93.answer": "No",
        "r95.answer": "No",
        "r97.answer": "No",
        "r99.answer": "No",
    },
    'C9.2': {
        "r10.comments": "Done",
        "r11.comments": "Done",
        "r12.comments": "Done",
        "r13.wpRef": "C9.1",
        "r14.comments": "Done",
        "r15.comments": "Done",
        "r16.comments": "Done",
        "r18.comments": "Yes",
        "r19.comments": "Yes",
        "r20.comments": "Yes",
        "r22.comments": "N/A",
        "r23.comments": "N/A",
        "r24.comments": "Yes",
        "r25.comments": "N/A",
        "r26.comments": "Yes",
        "r7.comments": "Yes",
        "r8.comments": "Yes",
    },
    'C10': {
        "r10.comments": "No",
        "r11.comments": "Yes",
        "r12.comments": "Yes",
        "r13.comments": "N/A",
        "r13.wpRef": "D4",
        "r14.comments": "N/A",
        "r14.wpRef": "Rapp02",
        "r15.comments": "N/A",
        "r15.wpRef": "W3",
        "r17.comments": "N/A",
        "r17.wpRef": "D5",
        "r18.comments": "N/A",
        "r18.wpRef": "D6",
        "r19.comments": "N/A",
        "r20.comments": "N/A",
        "r21.comments": "No changes",
        "r22.comments": "No",
        "r23.comments": "No",
        "r24.comments": "N/A",
        "r25.comments": "No unadjusted misstatements",
        "r25.wpRef": "B7",
        "r26.comments": "Done",
        "r26.wpRef": "C6",
        "r27.comments": "N/A",
        "r28.comments": "N/A",
        "r29.comments": "N/A",
        "r30.comments": "Done",
        "r6.comments": "N/A",
        "r6.wpRef": "I4",
        "r7.comments": "Yes",
        "r8.comments": "Yes",
        "r9.comments": "N/A",
        "r9.wpRef": "D2",
    },
    'C11': {
        "r11.comments": "Yes",
        "r12.comments": "Yes",
        "r13.comments": "Yes",
        "r14.comments": "Yes",
        "r15.comments": "Yes",
        "r16.comments": "Yes",
        "r17.comments": "Yes",
        "r18.comments": "Yes",
        "r19.comments": "Yes",
        "r6.comments": "Done",
        "r6.wpRef": "C13.3",
        "r7.comments": "Done",
        "r7.wpRef": "C13.4\nC13.5",
        "r8.comments": "Done",
        "r9.comments": "Done",
    },
    'C12': {
        "r10.comments": "Confirmed",
        "r11.comments": "Confirmed",
        "r12.comments": "N/A",
        "r7.comments": "N/A",
        "r8.comments": "Yes",
        "r9.comments": "Confirmed",
    },
    'Capp01': {
    },
};

/** Merge Excel sample defaults + API header defaults; non-blank saved values win. */
export function withCPageDefaults(
    pageCode: CSectionPageCode,
    saved: Record<string, string>,
    header: AuditProgramSectionVO,
): Record<string, string> {
    const sample = C_PAGE_DEFAULTS[pageCode] ?? {};
    const fromApi: Record<string, string> = {
        client: header.client ?? '',
        yearEnd: header.yearEnd ?? '',
        fileNo: header.fileNo ?? '',
        preparedBy: header.preparedInitial || header.preparedBy || '',
        reviewedBy: header.reviewedInitial || header.reviewedBy || '',
        ref: pageCode,
        partnerName: header.partnerName ?? '',
    };

    if (pageCode === 'C1') {
        const partner = header.partnerName || sample['team.partner.name'] || '';
        fromApi.partnerName = partner;
        fromApi.completionPartnerName = partner;
        fromApi['team.partner.name'] = partner;
        const partnerInitials = (header.reviewedInitial ?? '').trim();
        if (partnerInitials) {
            fromApi['team.partner.initials'] = partnerInitials;
        }
    }

    if (pageCode === 'C1a') {
        fromApi.prospectiveClientName = header.client ?? '';
        fromApi.periodEnding = header.yearEnd ?? '';
        fromApi.natureOfAssignment = sample.natureOfAssignment || 'Audit';
        fromApi['r172.name'] = header.partnerName || '';
    }

    const merged: Record<string, string> = {...fromApi, ...sample};
    for (const [k, v] of Object.entries(saved)) {
        if (!isBlank(v)) merged[k] = v;
    }
    // Prefer live auditor name / initials over Excel sample when API provides them
    const auditor = (header.partnerName ?? '').trim();
    const auditorInitials = (header.reviewedInitial ?? '').trim();
    if (auditor) {
        if (pageCode === 'C1') {
            if (isBlank(saved.partnerName)) merged.partnerName = auditor;
            if (isBlank(saved.completionPartnerName)) merged.completionPartnerName = auditor;
            if (isBlank(saved['team.partner.name'])) merged['team.partner.name'] = auditor;
            // Initials: blank, or legacy sample wrongly copied Manager's "ML"
            const savedPartnerInitials = (saved['team.partner.initials'] ?? '').trim();
            if (auditorInitials && (isBlank(savedPartnerInitials) || savedPartnerInitials === 'ML')) {
                merged['team.partner.initials'] = auditorInitials;
            }
        }
        if (pageCode === 'C1a' && isBlank(saved['r172.name'])) {
            merged['r172.name'] = auditor;
        }
        if (pageCode === 'C2.2' && isBlank(saved.engagementPartnerName)) {
            merged.engagementPartnerName = auditor;
        }
    }
    // C2.2: sample only ticks r7 + r13 Low; strip legacy all-Low threats and sample response ticks.
    if (pageCode === 'C2.2') {
        const extraThreatIds = ['r8', 'r9', 'r10', 'r11', 'r12', 'r14', 'r15'] as const;
        const extrasAllLow = extraThreatIds.every((id) => merged[`${id}.level`] === 'Low');
        if (extrasAllLow && merged['r7.level'] === 'Low' && merged['r13.level'] === 'Low') {
            for (const id of extraThreatIds) {
                delete merged[`${id}.level`];
            }
        }
        // Response ticks are not part of the sample defaults anymore.
        delete merged['r18.tick'];
        delete merged['r25.tick'];
    }
    // C4.1: replace short legacy sample (L / L / brief overall) with full Excel Depreciation row.
    if (pageCode === 'C4.1') {
        const legacyShort =
            merged['e1.inherent'] === 'L' &&
            merged['e1.control'] === 'L';
        if (legacyShort) {
            const sampleKeys = [
                'e1.estimate',
                'e1.outcome',
                'e1.inherent',
                'e1.control',
                'e1.overall',
                'e1.d3',
            ] as const;
            for (const k of sampleKeys) {
                if (!isBlank(sample[k])) merged[k] = sample[k];
            }
        }
    }
    // C5.1: replace legacy short sample rows with full Excel 8-row content.
    if (pageCode === 'C5.1') {
        const legacy =
            merged['r8.area'] === 'Sales system' ||
            (merged['r10.area'] === 'Receivables' && isBlank(merged['r14.area']));
        if (legacy) {
            for (const [k, v] of Object.entries(sample)) {
                if (!isBlank(v)) merged[k] = v;
            }
        }
    }
    return merged;
}

